import { render, staticRenderFns } from "./ThgBillingOverview.vue?vue&type=template&id=5cccfe92"
import script from "./ThgBillingOverview.vue?vue&type=script&lang=ts"
export * from "./ThgBillingOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports